import React, { Component } from "react";
import axios from "axios";
import { END_POINT } from "./endPoint";

export const HomepageContext = React.createContext();

export default class HomepageProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      machineList: JSON.parse(localStorage.getItem("machineList")) || [],
      serviceSummaryList:
        JSON.parse(localStorage.getItem("serviceSummaryList")) || [],
      topClaimList: JSON.parse(localStorage.getItem("topClaimList")) || [],
      maintenanceList:
        JSON.parse(localStorage.getItem("maintenanceList")) || [],
      serviceList:
        JSON.parse(localStorage.getItem("serviceList")) || [],
      clpmemberList:
        JSON.parse(localStorage.getItem("clpmemberList")) || [],
    };
  }

  getMachineStatusOverview = async (data) => {
    await axios
      .post(`${END_POINT}/get/machine_status_overview`, data)
      .then((res) => {
        console.log(res.data);
        if (res.status === 200) {
          localStorage.setItem("machineList", JSON.stringify(res.data));
          this.setState({ machineList: res.data });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getMaintenances = async (data) => {
    await axios
      .post(`${END_POINT}/get/maintenance`, data)
      .then((res) => {
        // console.log("ss",res.data);
        if (res.data.status.code === 0) {
          localStorage.setItem(
            "maintenanceList",
            JSON.stringify(res.data.data)
          );
          this.setState({ maintenanceList: res.data.data });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getService = async () => {
    await axios
      .post(`${END_POINT}/get/service`)
      .then((res) => {
        // console.log("dataservice",res.data);
        if (res.status === 200) {
          localStorage.setItem("serviceList", JSON.stringify(res.data));
          this.setState({ serviceList: res.data });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getServiceCount = async () => {
    let result = null;
    await axios
      .post(`${END_POINT}/get/service_count`)
      .then((res) => {
        // console.log("serviceLists",res.data);
        if (res.status === 200) {
          result = res.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });

    return result;
  };

  getServiceSummary = async (data) => {
    await axios
      .post(`${END_POINT}/get/service_summary`, data)
      .then((res) => {
        console.log(res.data);
        if (res.status === 200) {
          localStorage.setItem("serviceSummaryList", JSON.stringify(res.data));
          this.setState({ serviceSummaryList: res.data });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getTopClaim = async (data) => {
    await axios
      .post(`${END_POINT}/get/top_claim`, data)
      .then((res) => {
        console.log(res.data);
        if (res.status === 200) {
          localStorage.setItem("topClaimList", JSON.stringify(res.data));
          this.setState({ topClaimList: res.data });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getClpMembers = async (data) => {
    await axios
      .post(`${END_POINT}/get/clp_member_line_all`, data)
      .then((res) => {
        console.log("clpmemberList",res.data);
        if (res.status === 200) {
          localStorage.setItem("clpmemberList", JSON.stringify(res.data));
          this.setState({ clpmemberList: res.data });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getAllLinkDevice = async (data) => {
    await axios
      .post(`${END_POINT}/get_all_linked_devices`, data)
      .then((res) => {
        console.log("dataAll",res.data);
        if (res.status === 200) {
          localStorage.setItem(
            "allDevicesList",
            JSON.stringify(res.data.linkedDevices)
          );
          this.setState({ allDevicesList: res.data.linkedDevices });
        }
      })
      .catch((error) => {
        console.log(error);
      });
    return this.state.allDevicesList;
  };


  render() {
    const dataMaintenance = {
      machineList: this.state.machineList,
      serviceSummaryList: this.state.serviceSummaryList,
      topClaimList: this.state.topClaimList,
      maintenanceList: this.state.maintenanceList,
      serviceList: this.state.serviceList,
      serviceLists: this.serviceLists,
      clpmemberList: this.state.clpmemberList,
      allDevicesList: this.state.allDevicesList,

      getMachineStatusOverview: this.getMachineStatusOverview,
      getServiceSummary: this.getServiceSummary,
      getTopClaim: this.getTopClaim,
      getMaintenances: this.getMaintenances,
      getService: this.getService,
      getServiceCount: this.getServiceCount,
      getClpMembers: this.getClpMembers,
      getAllLinkDevice: this.getAllLinkDevice,
    };

    return (
      <HomepageContext.Provider value={dataMaintenance}>
        {this.props.children}
      </HomepageContext.Provider>
    );
  }
}

// MaintenanceProvider.contextType = UserContext;
